import { render, staticRenderFns } from "./RemoveUserList.vue?vue&type=template&id=5e61eaf0&"
import script from "./RemoveUserList.vue?vue&type=script&lang=js&"
export * from "./RemoveUserList.vue?vue&type=script&lang=js&"
import style0 from "./RemoveUserList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports